import { ClientSideDataGridModel } from "src/components/common/dataGrid/gridModel/ClientSideDataGridModel.tsx";
import { CatalogPartReferencesDataGridApi } from "src/api/generated/erp/parts/catalogPart/api/catalogPartReferencesDataGridApi.ts";
import { FormCrudDataGrid } from "src/components/common/dataGrid/crud/FormCrudDataGrid.tsx";
import { enumColumn, integerColumn, textColumn } from "src/components/common/dataGrid/columns.tsx";
import i18n from "i18next";
import { getPartRevisionStateLabels } from "src/api/generated/erp/db/types/enums/partRevisionState.ts";
import { AavoButton } from "src/components/common/buttons/AavoButton.tsx";
import { faSitemap } from "@fortawesome/pro-regular-svg-icons";
import { CatalogPartRevisionLineView } from "src/api/generated/erp/db/types/tables/catalogPartRevisionLineView.ts";
import { useGenericDialog } from "../../../../common/dialogs/GenericDialogContext.ts";
import { CatalogPartRevisionBomView } from "./CatalogPartRevisionBomView.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface CatalogPartReferencesDataGridProps {
	catalogPartId: number;
}

export const CatalogPartReferencesDataGrid = ({ catalogPartId }: CatalogPartReferencesDataGridProps) => {
	const { openDialog } = useGenericDialog();
	return (
		<ClientSideDataGridModel
			gridId={"B6D36825CD2088A6"}
			fetchData={() =>
				CatalogPartReferencesDataGridApi.getCatalogPartReferences({ catalogPartId: catalogPartId })
			}
			initialParams={{}}
			getRows={(data) => data}
			getRowId={(row) => row.catalogPartRevisionLineId}
			render={({ dataGridProps, onlySelectedRow }) => {
				return (
					<FormCrudDataGrid<CatalogPartRevisionLineView>
						columns={[
							textColumn({
								field: "parentPartNo",
								headerName: i18n.t("part"),
							}),
							textColumn({
								field: "parentPartDescription_1",
								headerName: i18n.t("description_1"),
								width: 200,
							}),
							textColumn({
								field: "parentPartDescription_2",
								headerName: i18n.t("description_2"),
								width: 200,
							}),
							integerColumn({
								field: "parentRevisionNumber",
								headerName: i18n.t("revision"),
							}),
							enumColumn({
								field: "parentRevisionState",
								headerName: i18n.t("revision_state"),
								enumLabels: getPartRevisionStateLabels(),
							}),
							integerColumn({
								field: "referenceNo",
								headerName: i18n.t("reference_no"),
							}),
						]}
						actionBarComponents={
							<>
								<AavoButton
									icon={faSitemap}
									label={i18n.t("product_structure")}
									variant={"outlined"}
									disabled={onlySelectedRow == null}
									onClick={() => {
										if (onlySelectedRow == null) return;
										openDialog({
											title: i18n.t("product_structure"),
											content: (
												<CatalogPartRevisionBomView
													catalogPartRevisionId={onlySelectedRow.catalogPartRevisionId}
													readOnly
												/>
											),
											agentContext: {
												key: defineAgentUiContextKey(
													"erp.parts.catalogPartReferenceProductStructure.dialog",
												),
												title: i18n.t("product_structure"),
												data: {
													lineCatalogPartId: onlySelectedRow.lineCatalogPartId,
													catalogPartRevisionId: onlySelectedRow.catalogPartRevisionId,
												},
											},
										});
									}}
								/>
							</>
						}
						agentContext={{
							key: defineAgentUiContextKey("erp.parts.catalogPartReferences.grid"),
							rowFields: [
								"catalogPartRevisionLineId",
								"catalogPartRevisionId",
								"parentCatalogPartId",
								"lineCatalogPartId",
							],
							selectedRowPathSegment: (row) => `${i18n.t("reference_no")} ${row.referenceNo}`,
						}}
						{...dataGridProps}
					/>
				);
			}}
		/>
	);
};
